import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetRequestService } from "./asset-requistion.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetRequestDto } from "./dto/asset-requisition.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";

@Controller('asset-request')
@ApiTags('asset-request')
export class AssetRequestController{
    constructor(
        private assetRequestService : AssetRequestService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createAssetRequest')
    async createAssetRequest(@Body() createDto:AssetRequestDto): Promise<CommonResponse> {
        try {
            return await this.assetRequestService.createAssetRequest(createDto);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getRequestedAssetsData')
    async getRequestedAssetsData(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetRequestService.getRequestedAssetsData(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getRequestCompletedAssets')
    async getRequestCompletedAssets(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetRequestService.getRequestCompletedAssets(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getAssetCodeDropDownforAssetRequest')
    async getAssetCodeDropDownforAssetRequest(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetRequestService.getAssetCodeDropDownforAssetRequest(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getAssetCategoryDropDown')
    async getAssetCategoryDropDown(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try {
            return await this.assetRequestService.getAssetCategoryDropDown(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
}